const cpfMascara = (valor: string) => {
  valor = valor.replace (/\D/g, '')
  valor = valor.replace(/(\d{3})(\d)/, "$1.$2")
  valor = valor.replace(/(\d{3})(\d)/, "$1.$2")
  valor = valor.replace(/(\d{3})(\d{1,2})$/, "$1 - $2")

  return valor
}

export default cpfMascara